import { withStyles } from '@material-ui/core'
import OktaSignIn from './OkatSignInWidget.origin'
import React, { useRef, useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch } from 'react-redux'
import compose from 'recompose/compose'
import withEntries from '../../Contexts/Entries/WithEntries.context'
import envGet from '../../Support/Env/Get/EnvGet.support'
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import TermsAndConditionsLink from '../TermsAndConditionsLink/TermsAndConditionsLink.component'
import oktaSignInWidgetStyles from './OktaSignInWidget.component.styles'
import authTnc from 'State/Store/Auth/Actions/AuthTnc.action'
import authForgotPassword from 'State/Store/Auth/Actions/AuthForgotPassword.action'
import authHelpLink from 'State/Store/Auth/Actions/AuthHelpLink.action'
import authUnlock from 'State/Store/Auth/Actions/AuthUnlock.action'
import ServicesContext from 'Contexts/Services/Services.context'
import { AUTH_FORGOT_PASSWORD_CLICKED, AUTH_HELP_LINK_CLICKED, AUTH_UNLOCK_CLICKED } from 'State/Store/Auth/Auth.types'
import hitGTM from 'State/Store/UI/Actions/GTM.action'

const baseUrl = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_BASE_URL` })
const clientId = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_CLIENT_ID` })
const issuer = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_ISSUER` })
const redirectUriLink = envGet({ key: `REACT_APP_ENTRY_PORTAL_CUSTOMER_OKTA_REDIRECT_URI` })

export const OktaSignInWidgetComponent = (props: any) => {
  const { entry, onError, onSuccess } = props
  const [ tncId, setTncId ] = useState<string | null>(null)
  const dispatch = useDispatch()
  const services = useContext(ServicesContext)
  const signInWidgetWrapperRef = useRef(null)
  const counterRef = useRef(0)
  const widget = useRef<any>(null)
  const [ isEventListenerAttached, setIsEventListenerAttached ] = useState(false)

  /**
   * Open email client
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const openEmailFeedback = () => {
    window.open("mailto:boralconnects@boral.com.au")
  }

  useEffect(() => {
    window.Backbone.history.stop()
    const el = signInWidgetWrapperRef.current
    const { logoLargeUrl: logo, name } = entry
    const redirectUri = `${window.location.origin}/implicit${redirectUriLink}`
    const scopes = services.authService.getScopes()
    const responseType = services.authService.getResponseTypes()
    widget.current = new OktaSignIn({
      authParams: {
        issuer,
        responseType,
        scopes,
        pkce: false,
        cookies: {
          secure: false,
        },
        display: 'popup',
      },
      baseUrl,
      clientId,
      features: {
        rememberMe: false,
        selfServiceUnlock: true,
        showPasswordToggleOnSignInPage: true,
      },
      helpLinks: {
        help: `/help`,
      },
      i18n: {
        en: {
          'account.unlock.email.or.username.placeholder': `Email`,
          'account.unlock.email.or.username.tooltip': `Registered Boral Connects Email`,
          'account.unlock.unlocked.desc': `You can log in using your existing Boral Connects email and password`,
          'error.username.required': `Please enter a registered Boral Connects email`,
          'password.complexity.no_username': `No parts of your Boral Connects email`,
          'password.forgot.email.or.username.placeholder': `Email`,
          'password.forgot.email.or.username.tooltip': `Registered Boral Connects Email`,
          'primaryauth.title': `Sign in to ${name}`,
          'primaryauth.username.placeholder': `Email`,
          'primaryauth.username.tooltip': `Registered Boral Connects Email`,
          'errors.E0000004': `You entered an incorrect email, password, or both.`,
        },
      },
      language: `en`,
      logo,
      redirectUri,
    })
    if (widget.current) {
      widget.current.renderEl({ el }, onSuccess(widget.current), (err: any) => {
        onError(widget.current)
      })
      widget.current.on(`pageRendered`, onSignInWidgetRendered)
      widget.current.on('afterError', (context:any, error:any) => {
        console.log('counterRef', counterRef.current)
        console.log(context);
        console.log(error);
        counterRef.current++;
        if (counterRef.current > 2) {
          // reset-password
          const forgetPassword = document.querySelector('[data-se="forgot-password"]') as HTMLElement
          if (document && document.querySelector('[data-se="forgot-password"]')) {
            forgetPassword.click();
            const errorEl = document.querySelector('[data-se="auth-container"]');
            const wrapper = document.createElement('div');
            wrapper.setAttribute(`id`, 'incorrectPasswordWrapper')
            wrapper.innerText = 'You have entered an incorrect email, password or both 3 times. Please enter your email address to reset your password.'
            wrapper.style.color = '#fff'
            wrapper.style.backgroundColor = '#d32f2f'
            wrapper.style.padding = '16px'
            wrapper.style.textAlign = 'center'
            wrapper.style.width = '100vw'
            if (errorEl && errorEl.parentElement && !document.getElementById('incorrectPasswordWrapper')) {
              errorEl.parentElement.insertBefore(wrapper, errorEl)
            }
          }
        }
      })
    }
    return () => {
      if (widget.current) {
        widget.current.remove()
      }
    }
  }, [])

  function onSignInWidgetRendered() {
    // remove message first if already exists
    const existingErrorMsg = document.getElementById('incorrectPasswordWrapper');
    if (existingErrorMsg && document && document.querySelector('[data-se="forgot-password"]')) {
      existingErrorMsg.remove();
    }
    const authContainer = document.querySelector(`[data-se="auth-container"]`)
    if (authContainer) {
      const tncId = `tnc-link`
      const placeholder = document.createElement(`div`)
      placeholder.setAttribute(`id`, tncId)
      placeholder.addEventListener(`click`, () => {
        dispatch(authTnc())
      })
      authContainer.after(placeholder)
      setTncId(tncId)
    }

    appendForgetPasswordAndUnlockAccount()
    appendSumitFeedbackAndHelp()
    appendRegisterButton()
    hideNeedHelp()
    addEventListenerForActions()
  }

  function addEventListenerForActions() {
    if (!isEventListenerAttached) {
      const helpLinkActions = {
        [`forgot-password`]: AUTH_FORGOT_PASSWORD_CLICKED,
        [`help-link`]: AUTH_HELP_LINK_CLICKED,
        [`unlock`]: AUTH_UNLOCK_CLICKED,
      }
      Object.keys(helpLinkActions).forEach((helpLinkDataId: string) => {
        const el = document.querySelector(`a[data-se=${helpLinkDataId}]`)
        if (el) {
          setIsEventListenerAttached(true)
          el.addEventListener(`click`, () => {
            dispatch(hitGTM(helpLinkActions[helpLinkDataId as 'forgot-password' | 'help-link' | 'unlock']))
          })
        }
      })
    }
  }
  function appendForgetPasswordAndUnlockAccount() {
    const wrapperId = `ForgetPasswordAndUnlockAccountId`
    const authFooter = document.querySelector(`.auth-footer`) as HTMLElement
    const forgetPassword = document.querySelector('[data-se="forgot-password"]') as HTMLElement
    const unlockAccount = document.querySelector('[data-se="unlock"]') as HTMLElement
    if (authFooter && forgetPassword && unlockAccount && !document.querySelector(`#${wrapperId}`)) {
      forgetPassword.innerHTML = `Reset Password`
      forgetPassword.style.textDecoration = 'underline'
      forgetPassword.style.display = 'inline-block'
      unlockAccount.innerHTML = `Unlock account`
      unlockAccount.style.textDecoration = 'underline'
      unlockAccount.style.display = 'inline-block'
      const wrapper = document.createElement('div') as HTMLElement
      wrapper.id = wrapperId
      wrapper.append(
        forgetPassword,
        ` | `,
        unlockAccount,
      )
      authFooter.append(wrapper)
    }
  }
  function appendSumitFeedbackAndHelp() {
    const wrapperId = 'SumitFeedbackAndHelpId'
    const authFooter = document.querySelector(`.auth-footer`)
    const helpLink = document.querySelector('[data-se="help-link"]') as HTMLElement
    if (!authFooter || !helpLink || document.querySelector(`#${wrapperId}`)) return
    helpLink.setAttribute(`target`, `_self`)
    helpLink.style.textDecoration = 'underline'
    helpLink.style.display = 'inline-block'

    const feedbackLinkId = `submit-feedback-link`
    const feedbackLink = document.createElement(`a`)
    feedbackLink.innerHTML = `Submit Feedback`
    feedbackLink.setAttribute(`href`, `###`)
    feedbackLink.setAttribute(`id`, feedbackLinkId)
    feedbackLink.style.textDecoration = 'underline'
    feedbackLink.style.display = 'inline-block'
    feedbackLink.addEventListener(`click`, () => openEmailFeedback())

    const wrapper = document.createElement('div') as HTMLElement
    wrapper.style.margin = `2em 0`
    wrapper.id = wrapperId
    wrapper.append(
      `Having issues signing in? Please `,
      feedbackLink,
      ` or visit the `,
      helpLink,
      ` page`,
    )
    authFooter.append(wrapper)
  }
  function appendRegisterButton() {
    const authFooter = document.querySelector(`.auth-footer`)
    const wrapperId = `RegisterButtonId`
    if (!authFooter || document.querySelector(`#${wrapperId}`)) return
    const newToBoralConnects = document.createElement('div')
    newToBoralConnects.innerHTML = `New to Boral Connects?`
    newToBoralConnects.style.cssText = `
      display: block;
      padding: 1em 0;
    `

    const registerNowLink = document.createElement('a')
    registerNowLink.href = 'https://register.boralconnects.com.au/form'
    registerNowLink.target = '_blank'
    registerNowLink.innerHTML = 'Register Now'
    registerNowLink.style.cssText = `
      display: block;
      width: 100%;
      color: #00A94F;
      background-color: #f5f5f5;
      padding: 7px 0;
      font-size: 14px;
      line-height: 36px;
      border: none;
      cursor: pointer;
      text-align: center;
    `
    const wrapper = document.createElement('div')
    wrapper.id = wrapperId
    wrapper.append(newToBoralConnects, registerNowLink)
    authFooter.append(wrapper)
  }
  function hideNeedHelp() {
    const needhelp = document.querySelector('[data-se="needhelp"]') as any
    if (!needhelp) return
    needhelp.hidden = true
    needhelp.style.display = 'none'
  }

  function renderTermsAndConditionsLink() {
    if (tncId) {
      const mountId = document.getElementById(tncId)
      if (mountId) {
        return ReactDOM.createPortal(<TermsAndConditionsLink />, mountId)
      }
    }
  }

  return (
    <React.Fragment>
      <div ref={signInWidgetWrapperRef} style={{ height: `100%`, overflowY: `auto` }} />
      {renderTermsAndConditionsLink()}
    </React.Fragment>
  )
}

const OktaSignInWidget = compose(
  withStyles(themeCreateInjectableStyles(oktaSignInWidgetStyles) as any, { withTheme: true }),
  withEntries,
)(OktaSignInWidgetComponent)

export default OktaSignInWidget
